import {
  DAFAULT_POLICY_TERM,
  DAFAULT_PREMIUM_PAYMENT_TERM,
  DEFAULT_PARTNER_CODE,
} from "../constants";
import { getStorageItem } from "../helpers/utils";
import { buildLifeCoverageMapping } from "../helpers/product";

export const riders = {
  ADBR: false,
  CCR: false,
  CI: false,
  CHB: false,
  DDR: false,
  HGR: false,
  TPR: false,
  CER: false,
};

export const initialFormState = {
  // Page
  category: "",
  dob: "",
  quotationId: "",
  multipierFactor: 12,
  productName: "",
  ekycPartner: "",
  productConfig: null,
  education: "",

  // Premium
  pid: "",
  age: "",
  type: "",
  gender: "Male",
  smoker: "Non Smoker",
  ccrider: false,
  cirider: false,
  adbrider: false,
  ccridersa: 50000,
  ciridersa: 50000,
  adbridersa: 50000,
  pt: DAFAULT_POLICY_TERM,
  ppt: DAFAULT_PREMIUM_PAYMENT_TERM,
  sumassured: null,
  optionId: "", // "1", // : "2",
  paymentFrequency: "Yearly",
  occupation: "Salaried",
  annualIncome: "",

  // Plan Riders
  riders: { ...riders },

  // Quotation
  corpus: "",
  premium: "",
  premiumIncludingGst: "",
  premiumExcludingGst: "",
  dealthSumAssured: "",
  guaranteeSumAssured: "",
  maturitySumAssured: "",
  maturityTerminalBonus1: "",
  maturityTerminalBonus2: "",

  // Option List
  corpusOptions: [],
  premiumOptions: [],
  occupationOptions: [],
  savingGrid: [],
  language: getStorageItem("partnerCode") === DEFAULT_PARTNER_CODE ? "2" : "1",
};

export const options = {
  gender: [
    { title: "Male", value: "Male" },
    { title: "Female", value: "Female" },
  ],
  paymentFrequency: [
    { title: "Yearly", value: "Yearly" },
    { title: "Monthly", value: "Monthly" },
  ],
  language: [
    { title: "English", value: "0" },
    { title: "Hindi", value: "1" },
    { title: "Marathi", value: "2" },
  ],
  nonMarathiLanguage: [
    { title: "English", value: "0" },
    { title: "Hindi", value: "1" },
  ],
};

export const mapping = {
  premium: {
    1000: {
      title: "1K", // ₹
    },
    2000: { title: "2K" },
    3000: { title: "3K" },
    4000: { title: "4K" },
    5000: { title: "5K" },
    6000: { title: "6K" },
    9000: { title: "9K" },
    12000: {
      title: "12K",
    },
    15000: {
      title: "15K",
    },
    18000: {
      title: "18K",
    },
    24000: {
      title: "24K",
    },
    30000: {
      title: "30K",
    },
    36000: {
      title: "36K",
    },
    48000: {
      title: "48K",
    },
    60000: {
      title: "60K",
    },
  },
  corpus: buildLifeCoverageMapping(),
  corpus1: {
    200000: { title: "2L", label: "2 Lacs" },
    300000: { title: "3L", label: "3 Lacs" },
    500000: { title: "5L", label: "5 Lacs" },
    1000000: { title: "10L", label: "10 Lacs" },
    1500000: { title: "15L", label: "15 Lacs" },
    2000000: { title: "20L", label: "20 Lacs" },
    2500000: { title: "25L", label: "25 Lacs" },
    3000000: { title: "30L", label: "30 Lacs" },
    3500000: { title: "35L", label: "35 Lacs" },
    4000000: { title: "40L", label: "40 Lacs" },
    4500000: { title: "45L", label: "45 Lacs" },
    5000000: { title: "50L", label: "50 Lacs" },
  },
  languageFactsheet: {
    0: "factSheet.pdf",
    1: "factSheet-hindi.pdf",
    2: "factSheet-marathi.pdf",
  },
  paymentFrequency: {
    Monthly: 1,
    Quarterly: 3,
    "Half Yearly": 6,
    Yearly: 12,
  },
  maxAgeLimit: {
    SAVINGS: 51,
    TERM: getStorageItem("userType") === "NONPOS" ? 46 : 46,
  },
  minAgeLimit: {
    SAVINGS: 18,
    TERM: 18,
  },
  riders: {
    ADBR: {
      premium: "ADBRPremium",
    },
    CCR: {
      premium: "CCRPremium",
    },
    CI: {
      premium: "CIPremium",
    },
    CHB: {
      premium: "CHBPremium",
    },
    DDR: {
      premium: "DDRPremium",
    },
    HGR: {
      premium: "HGRPremium",
    },
    TPR: {
      premium: "TPRPremium",
    },
    CER: {
      premium: "CERPremium",
    },
  },
};
